/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

export default freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/redux/~/lodash-es/_freeGlobal.js
// module id = 2430
// module chunks = 1